import { createSlice } from '@reduxjs/toolkit';

import { flightTimeLoaded, initFailed, initSucceeded } from '../../actions/priceMatrixActions';

// `initialized` is derived differently on each outcome: always false on a failure, and true on a
// success only when transport data actually arrived. Both spread over the previous state when the
// action carries none, which is why a null start yields `{ initialized: false }`.
const transportDataSlice = createSlice({
  name: 'transportData',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initFailed, (state, action) => ({ ...(action.payload.transportData || state), initialized: false }))
      .addCase(initSucceeded, (state, action) => ({
        ...(action.payload.transportData || state),
        initialized: !!action.payload.transportData,
      }))
      .addCase(flightTimeLoaded, (state, action) => ({ ...state, flightTimeInformation: action.payload }));
  },
});

export default transportDataSlice.reducer;
